const $$splitComponentImporter = () => import('/home/runner/work/zngly-corporate/zngly-corporate/wp-content/themes/zngly-corporate/frontend/src/routes/dash/crm/contacts/lists/$listId/handpick.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { type Contact_Pagination_Fragment$data, type Contact_Pagination_Fragment$key, ContactsRootQuery, type Contacts_Root_Query } from '@/graphql/queries/Contact.query';
import { RelayEnvironment } from '@/graphql/relay-env';
import { usePaginationFragment } from '@/graphql/relay.utils';
import { createFileRoute } from '@tanstack/react-router';
import { loadQuery } from 'react-relay';
import type { DeepOmit, DeepWritable } from 'ts-essentials';
type ContactColumnNode = DeepOmit<DeepWritable<NonNullable<Contact_Pagination_Fragment$data['contacts']>['edges'][number]['node']>, {
  properties: never;
  formEntries: never;
  databaseId: never;
}>;
type Table1RelayData = ReturnType<typeof usePaginationFragment<Contacts_Root_Query, Contact_Pagination_Fragment$key>>;
type Table1ComponentProps = {
  isFallback?: boolean;
} & Partial<Table1RelayData>;
export const Route = createFileRoute('/dash/crm/contacts/lists/$listId/handpick')({
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr),
  loader: () => {
    return loadQuery<Contacts_Root_Query>(RelayEnvironment, ContactsRootQuery, {}, {
      fetchPolicy: 'store-or-network'
    });
  }
});